<template>
  <v-app>
    <v-content>
      <v-container color="grey" fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-form @submit.prevent="tryToLogin">
              <v-card class="elevation-12">
                <v-toolbar dark color="primary">
                  <v-toolbar-title>Logowanie</v-toolbar-title>

                  <v-spacer />

                  <v-toolbar-title>{{ applicationTitle }}</v-toolbar-title>
                </v-toolbar>

                <v-alert v-model="showError" class="mt-3 mx-3" type="error" outline>{{ errorMessage }}</v-alert>

                <v-card-text>
                  <v-text-field
                    prepend-icon="person"
                    v-model="login"
                    name="login"
                    label="Login"
                    type="text"
                    placeholder=" "
                  />

                  <v-text-field
                    v-model="password"
                    id="password"
                    prepend-icon="lock"
                    name="password"
                    label="Hasło"
                    hint="Hasło musi składać się z minimum 8 znaków (w tym cyfry, znaku specjalnego oraz wielkiej litery)"
                    placeholder=" "
                    :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                    :type="showPassword ? 'text' : 'password'"
                    @click:append="showPassword = !showPassword"
                  />
                </v-card-text>

                <v-card-actions>
                  <router-link class="ma-2" :to="{ name: 'reset' }">Zapomniałem hasła</router-link>

                  <router-link class="ma-2" :to="{ name: 'resend' }">Wyślij link aktywacyjny</router-link>

                  <v-spacer />

                  <v-btn type="submit" color="primary">Login</v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { config } from '@/utils/config';

// @vuese
// Formularz logowania
// @group Auth
export default {
  data() {
    return {
      applicationTitle: config.applicationTitle,
      showPassword: false,
      password: undefined,
      login: undefined,
      showError: false,
      errorMessage: undefined
    };
  },
  methods: {
    // @vuese
    // Metoda próbuje zalogować użytkownika po podanych danych
    tryToLogin() {
      const invalidPasswordMessage = 'Niepoprawny login lub hasło';

      this.$store
        .dispatch('auth/login', { login: this.login, password: this.password })
        .then(res => {
          const profileTarget = res.profile.partner ? 'placeSelect' : 'profile';
          const target = res.hasAllConsents ? profileTarget : 'termsCurrent';
          this.$router.push({ name: target });
        })
        .catch(error => {
          const message = error.message || error;
          if (message.includes(invalidPasswordMessage)) {
            this.errorMessage = invalidPasswordMessage;
          } else {
            this.errorMessage = message;
          }
        });
    }
  },
  watch: {
    errorMessage(val) {
      if (val) {
        this.showError = true;
      }
    },
    showError(val) {
      if (!val) {
        this.errorMessage = undefined;
      }
    }
  }
};
</script>
